import { PropsWithChildren } from 'react';
import { FieldError, Merge } from 'react-hook-form';

interface FormFieldContainerProps extends PropsWithChildren {
	label?: string;
	className?: string;
	error?: FieldError | Merge<FieldError, FieldError>;
}

const FormFieldContainer = ({ label, className, children }: FormFieldContainerProps) => {
	return (
		<div className={className}>
			<p className="headline-4">{label}</p>
			{children}
			{/* {error && <p className="text-xs text-circles-error">{error.message}</p>} */}
		</div>
	);
};

export default FormFieldContainer;
